import { render, staticRenderFns } from "./BridgeDocumentsView.vue?vue&type=template&id=664ec74f"
import script from "./BridgeDocumentsView.vue?vue&type=script&lang=ts"
export * from "./BridgeDocumentsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports